import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AdSlot } from 'react-dfp';
import exact from 'prop-types-exact';
import shouldUseGam from '../../helpers/shouldUseGam';
import { useOptionalCookies } from '../../helpers/optionalCookies';

/*
*DFP Banner component
* If multiple ad sizes are given, they should be mappend via the sizeMapping array.
* If no title is given, none will be shown and the horizontal lines will also not be present.
* All banner will have a default banner class added, with the default banner styles. (.banner-default)
*/

// Note: React.memo works like PureComponent and does a shallow comparison of the props to determine if rerendering is necessary.
// This avoids rerendering without anything changing, just like shouldComponent update would do when returning always false

const Banner = React.memo(({ config, isPro, profileInitialized }) => {
    const consent = useOptionalCookies();
    const [showBanner, setShowBanner] = useState(false);
    const shouldUseGamAds = shouldUseGam();

    // The following is executed only once the component didMount and this only happens on the client
    useEffect(() => {
        if (profileInitialized) {
            // show or hide the banner based on the isPro parameter, once the profile was initialized
            setShowBanner(!isPro);
        }
    }, [profileInitialized, isPro]);

    if (!showBanner || !consent) {
        return null;
    }

    return (
        <div className={config.title ? 'containerBanner' : 'containerBannerSlim'}>
            {config.title &&
            <p className="banner-title">
                {config.title}
            </p>}
            <div className={`banner-default ${config.class}${config.title ? ' lines' : ''}`}>
                { shouldUseGamAds ?
                    <AdSlot
                        adUnit={config.adUnit}
                        sizes={config.sizes}
                        sizeMapping={config.sizeMapping || null}
                        shouldRefresh={() => config.shouldRefresh}
                    /> :
                    <div className="devBannerText">no banner in development</div>}
            </div>
        </div>
    );
});

Banner.propTypes = exact({
    config: PropTypes.shape({
        title: PropTypes.string,
        class: PropTypes.string.isRequired,
        adUnit: PropTypes.string.isRequired,
        sizes: PropTypes.arrayOf(PropTypes.array).isRequired,
        sizeMapping: PropTypes.arrayOf(PropTypes.object),
        shouldRefresh: PropTypes.bool.isRequired,
    }).isRequired,
    isPro: PropTypes.bool,
    profileInitialized: PropTypes.bool.isRequired,
});

const mapStateToProps = (state) => ({
    isPro: state.profile.user.isPro,
    profileInitialized: state.profile.profileInitialized,
});

export default connect(mapStateToProps, {})(Banner);
